import { API } from "../../../utils/Apis";
import {
  adminBlockVenue,
  createVanue,
  deleteVanue,
  getAdminUsersList,
  getAdminVanues,
  getMyVanues,
  updateUserListItem,
  updateVanue,
} from "../Reducers/VanueReducers";
import { AppDispatch } from "../Store";

export const createNewVenueAction = (data: any, dispatch: AppDispatch) =>
  API.createNewVenue(data).then((res) => {
    if (res.type === "success") {
      // carry the submitted status forward so the list badge (e.g. Draft)
      // is correct immediately, even if the create response omits it
      const item = { status: data?.status, ...res.data };

      dispatch(createVanue({ item }));
    }
    return res;
  });

export const updateVenueAction = (data: object, dispatch: AppDispatch) =>
  API.updateVanue(data).then((res) => {
    if (res.type === "success") {
      dispatch(updateVanue({ item: res.data }));
    }

    return res;
  });

export const deleteVenueAction = (data: object, dispatch: AppDispatch) =>
  API.deleteVenue(data).then((res) => {
    if (res.type === "success") {
      dispatch(deleteVanue({ id: data.id }));
    }

    return res;
  });

export const getVenuesAction = (data: object, dispatch: AppDispatch) =>
  API.getUserVanues(data).then((res) => {
    if (res.type === "success") {
      dispatch(getMyVanues({ items: res.data }));
    }

    return res;
  });

export const getAdminVenuesAction = (data: object, dispatch: AppDispatch) =>
  API.getAdminVanues(data).then((res) => {
    if (res.type === "success") {
      dispatch(getAdminVanues({ items: res.data }));
    }

    return res;
  });

export const adminBlockVenueAction = (data: object, dispatch: AppDispatch) =>
  API.adminBlockVenue(data).then((res) => {
    if (res.type === "success") {
      dispatch(adminBlockVenue({ id: data.id }));
    }

    return res;
  });

export const getAdminUserListAction = (data: object, dispatch: AppDispatch) =>
  API.getUsersList(data).then((res) => {
    if (res.type === "success") {
      dispatch(getAdminUsersList({ items: res.data }));
    }

    return res;
  });

export const blockUserAction = (data: object, dispatch: AppDispatch) =>
  API.blockUserItem(data).then((res) => {
    if (res.type === "success") {
      dispatch(updateUserListItem({ id: data.id }));
    }

    return res;
  });
